import * as React from "react";
import type { SVGProps } from "react";
const SvgKey01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.679 6.6H7.8m6.818 2.782 6.69 6.689a1 1 0 0 1 .292.707V20.6a1 1 0 0 1-1 1h-2.49v-2.618h-2.62v-2.618l-3.224-3.037a6.11 6.11 0 1 1 2.352-4.818z"
    />
  </svg>
);
export default SvgKey01;
